var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 151"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 40.2805,
    cy: 39.658,
    r: 39.4085,
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.4748 28.1622C24.0937 28.1622 23.7282 28.0108 23.4587 27.7413C23.1892 27.4719 23.0378 27.1064 23.0378 26.7253C23.0378 26.3442 23.1892 25.9787 23.4587 25.7092C23.7282 25.4397 24.0937 25.2883 24.4748 25.2883H56.0876C56.4687 25.2883 56.8342 25.4397 57.1037 25.7092C57.3731 25.9787 57.5245 26.3442 57.5245 26.7253C57.5245 27.1064 57.3731 27.4719 57.1037 27.7413C56.8342 28.0108 56.4687 28.1622 56.0876 28.1622H24.4748ZM30.2226 22.4144C29.8415 22.4144 29.476 22.263 29.2065 21.9935C28.937 21.7241 28.7856 21.3586 28.7856 20.9775C28.7856 20.5964 28.937 20.2309 29.2065 19.9614C29.476 19.6919 29.8415 19.5405 30.2226 19.5405H50.3398C50.7209 19.5405 51.0864 19.6919 51.3559 19.9614C51.6254 20.2309 51.7768 20.5964 51.7768 20.9775C51.7768 21.3586 51.6254 21.7241 51.3559 21.9935C51.0864 22.263 50.7209 22.4144 50.3398 22.4144H30.2226ZM17.29 55.4642C17.29 56.6075 17.7442 57.704 18.5527 58.5124C19.3611 59.3209 20.4576 59.775 21.6009 59.775H58.9615C60.1048 59.775 61.2013 59.3209 62.0097 58.5124C62.8182 57.704 63.2723 56.6075 63.2723 55.4642V35.3469C63.2723 34.2036 62.8182 33.1072 62.0097 32.2987C61.2013 31.4903 60.1048 31.0361 58.9615 31.0361H21.6009C20.4576 31.0361 19.3611 31.4903 18.5527 32.2987C17.7442 33.1072 17.29 34.2036 17.29 35.3469V55.4642ZM21.6009 56.9011C21.2198 56.9011 20.8543 56.7498 20.5848 56.4803C20.3153 56.2108 20.1639 55.8453 20.1639 55.4642V35.3469C20.1639 34.9658 20.3153 34.6003 20.5848 34.3309C20.8543 34.0614 21.2198 33.91 21.6009 33.91H58.9615C59.3426 33.91 59.7081 34.0614 59.9776 34.3309C60.247 34.6003 60.3984 34.9658 60.3984 35.3469V55.4642C60.3984 55.8453 60.247 56.2108 59.9776 56.4803C59.7081 56.7498 59.3426 56.9011 58.9615 56.9011H21.6009Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconss);
export default __webpack_public_path__ + "static/media/iconss.de06d2d0efd0bc6f87001d54c0f410f1.svg";
export { ForwardRef as ReactComponent };